module.exports = __webpack_public_path__ + "static/media/ctb.989686d5.jpg";